import React from 'react';
import { gatedSaleState } from './state';
import { toLocalCurrencyShowEstimate } from 'src/scripts/utils/currency';
import { openSignInModal } from 'src/scripts/templates/_shared/ui-components/SignInModal/utils';
import { getGatedSalePriceWithLabel, getGatedSalePriceLabelColor } from 'src/scripts/utils/gatedSaleUtils';
import './styles.scss';

const GatedSaleProductPrice = (props: { price: number; compareAtPrice: number }) => {
  const { price, compareAtPrice } = props;
  const { appGatedSaleConfig } = gatedSaleState;

  const displayPrice = toLocalCurrencyShowEstimate(compareAtPrice);
  const gatedSaleCopy = getGatedSalePriceWithLabel(toLocalCurrencyShowEstimate(price));

  return (
    <div
      className={`gated-sale-price-wrapper ${appGatedSaleConfig.isEnabled ? 'app-gated' : 'member-gated'}`}
      style={{ '--gated-sale-price-color': getGatedSalePriceLabelColor() } as React.CSSProperties}
    >
      <span
        className="gated-sale-display-price"
        data-currency
        tabIndex={0}
        aria-label={`Original price: ${displayPrice}`}
      >
        {displayPrice}
      </span>
      {gatedSaleCopy && (
        <span
          className="gated-sale-discount-message"
          dangerouslySetInnerHTML={{ __html: gatedSaleCopy }}
          onClick={handleClick}
        ></span>
      )}
    </div>
  );
};

const handleClick = (event: React.MouseEvent<HTMLElement>) => {
  const target = event.target as HTMLElement;
  if (target.tagName.toLowerCase() === 'a') {
    const url = target.getAttribute('href') || '';
    if (url.includes('/account/login')) {
      event.preventDefault();
      const urlParams = new URLSearchParams(url);
      openSignInModal({ tab: urlParams.get('newUser') === 'true' ? 'sign-in' : 'create-account' });
    }
  }
};

export default GatedSaleProductPrice;
